module.exports = __webpack_public_path__ + "static/media/img3-5.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img3-5.png
// module id = 1533
// module chunks = 3